const Program = ({ concert, t }) => {
  return (
    <>
      {concert.program.length > 0 && (
        <>
          <h4 className="text-capitalize titlenotaligned mt-5 mb-4">
            {t("concerts.program")}
          </h4>

          <div className="concert-program-list">
            {concert.program.map(({ composer, piece, movements, id }) => (
              <div className="row program-item align-items-baseline mb-3 pb-3" key={id}>
                <div className="col-12 col-md-4">
                  <h5 className="composer-name text-capitalize mb-1">{composer}</h5>
                </div>
                <div className="col-12 col-md-8">
                  <h5 className="piece-title mb-0">{piece}</h5>
                  {movements.length > 0 && (
                    <ul className="list-unstyled movements-list mt-2 mb-0">
                      {movements.map((movement, index) => (
                        <li key={index} className="movement-item">
                          <span className="text-capitalize">{movement}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Program;
